/** @jsx jsx */
import { css, jsx } from "@emotion/core"

import React from "react"
import { Grid } from "@cd2/components"
import { FloatingBox } from "./Misc/FloatingBox"

interface IProps {
  children: React.ReactNode
  rightFilters?: React.ReactNode
}

export function IndexFilterWrapper({ children, rightFilters }: IProps) {
  if (rightFilters) {
    return (
      <Grid columns={["auto", "auto"]} gap={32}>
        <div>{children}</div>
        {rightFilters && <div>{rightFilters}</div>}
      </Grid>
    )
  }

  return (
    <FloatingBox
      css={css`
        max-width: 600px;
        width: 100%;
      `}
    >
      {children}
    </FloatingBox>
  )
}
